import { useEffect, useState, type CSSProperties } from 'react'
import { COLORS, RADIUS } from '../styles/tokens'

const STORAGE_KEY = 'save-error-dismissed'

interface SaveErrorBannerProps {
  message: string
  dismissLabel: string
  onDismiss: () => void
}

export default function SaveErrorBanner({ message, dismissLabel, onDismiss }: SaveErrorBannerProps) {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1'
    } catch {
      return false
    }
  })

  useEffect(() => {
    if (dismissed) {
      try {
        sessionStorage.setItem(STORAGE_KEY, '1')
      } catch { /* ignore */ }
    }
  }, [dismissed])

  const handleDismiss = () => {
    setDismissed(true)
    onDismiss()
  }

  if (dismissed) return null

  return (
    <div style={s.banner}>
      <span>{message}</span>
      <button
        onClick={handleDismiss}
        style={s.btn}
        aria-label={dismissLabel}
      >
        {dismissLabel}
      </button>
    </div>
  )
}

const s: Record<string, CSSProperties> = {
  banner: {
    position:      'fixed',
    top:           16,
    left:          '50%',
    transform:     'translateX(-50%)',
    background:    COLORS.warningBg,
    border:        `1px solid ${COLORS.warningBorder}`,
    borderRadius:  RADIUS.md,
    padding:       '10px 20px',
    fontSize:      16,
    color:         COLORS.warningText,
    zIndex:        1000,
    textAlign:     'center',
    maxWidth:      '90vw',
    display:       'flex',
    alignItems:    'center',
    gap:           12,
  },
  btn: {
    background:    'transparent',
    border:        `1px solid ${COLORS.warningText}`,
    borderRadius:  RADIUS.sm,
    color:         COLORS.warningText,
    fontSize:      14,
    padding:       '4px 12px',
    cursor:        'pointer',
    fontWeight:    600,
    flexShrink:    0,
    minHeight:     48,
    minWidth:      48,
  },
}
